export default {
  AddSubsPlanAmountAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addPlanAmount", payload)
      resolve()
    })
  }
}
